module.exports = __webpack_public_path__ + "img/test3.67add50a.jpeg";